import { LoginComponent } from './auth/login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { Module } from './shared/global';
import { LibCallbackComponent, LibNotAuthorizedComponent } from 'ngx-mat-base-comp';
import { MainComponent } from './layout/main/main.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'callback',
    component: LibCallbackComponent,
  },
  {
    path: 'notauthorized',
    component: LibNotAuthorizedComponent
  },
  {
    path: Module.Core,
    component: MainComponent,
    data: { module: ''},
    canActivate: [AuthGuard]
  },
  {
    path: Module.Sales,
    loadChildren: () => import('./modules/sales/sales.module').then(mod => mod.SalesModule),
    data: { module: Module.Sales },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Setting,
     loadChildren: () => import('./modules/setting/setting.module').then(mod => mod.SettingModule),
    data: { module: Module.Setting },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Report,
    loadChildren: () => import('./modules/report/report.module').then(mod => mod.ReportModule),
    data: { module: Module.Report },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Entity,
    loadChildren: () => import('./modules/entity/entity.module').then(mod => mod.EntityModule),
    data: { module: Module.Entity },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Receiving,
    loadChildren: () => import('./modules/receiving/receiving.module').then(mod => mod.ReceivingModule),
    data: { module: Module.Receiving },
    canActivate: [AuthGuard]
  },
  {
    path: Module.TechRepair,
    loadChildren: () => import('./modules/tech-repair/tech-repair.module').then(mod => mod.TechRepairModule),
    data: { module: Module.TechRepair },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Inspection,
    loadChildren: () => import('./modules/inspection/inspection.module').then(mod => mod.InspectionModule),
    data: { module: Module.Inspection },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Billing,
    loadChildren: () => import('./modules/billing/billing.module').then(mod => mod.BillingModule),
    data: { module: Module.Billing },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Zeus,
    loadChildren: () => import('./modules/zeus/zeus.module').then(mod => mod.ZeusModule),
    data: { module: Module.Zeus },
    canActivate: [AuthGuard]
  },
  {
    path: Module.Inventory,
    loadChildren: () => import('./modules/inventory/inventory.module').then(mod => mod.InventoryModule),
    data: { module: Module.Inventory },
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: Module.Core
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
